import {
  OrderValue as MainOrderValue,
  sortableColumns as mainSortableColumns,
  tagColumnNames as mainTagColumns,
  TagColumnNames as MainTagColumns,
} from 'pages/admin/mentoring/binomes';
import {
  defaultExportColumns,
  ExportColumn,
  exportColumnNames,
  ExportColumns,
} from 'pages/admin/mentoring/binomes/Export';
import ActionTypes from 'store/actionTypes/admin/binomeLists';
import { updateObject } from 'store/updateObject';
import Tags from 'types/Tags';
import {
  isColumns,
  isNumberAction,
  isOrderAction,
  isStringAction,
  isTagsAction,
  TypedAction,
} from 'types/typeguards/reducerActions';

export type BinomeListsState = {
  main: {
    page: number;
    tags: Tags<MainTagColumns>;
    search: string;
    take: number;
    order: MainOrderValue;
    exportColumns: Record<ExportColumn, boolean>;
  };
};

const initialState: BinomeListsState = {
  main: {
    page: 0,
    tags: {
      status: [],
      referee: [],
    },
    search: '',
    take: 100,
    order: 'desc/createdAt',
    exportColumns: defaultExportColumns,
  },
};

const setPage = (state: BinomeListsState, action: TypedAction<number>) =>
  updateObject(state, { main: updateObject(state.main, { page: action.value }) });

const setSearch = (state: BinomeListsState, action: TypedAction<string>) =>
  updateObject(state, {
    main: updateObject(state.main, { search: action.value, page: 0 }),
  });

const setMainTags = (
  state: BinomeListsState,
  action: TypedAction<Tags<MainTagColumns>>,
) =>
  updateObject(state, {
    main: updateObject(state.main, { tags: action.value, page: 0 }),
  });

const setTake = (state: BinomeListsState, action: TypedAction<number>) =>
  updateObject(state, {
    main: updateObject(state.main, { take: action.value, page: 0 }),
  });

const setOrderMain = (
  state: BinomeListsState,
  action: TypedAction<MainOrderValue>,
) =>
  updateObject(state, {
    main: updateObject(state.main, { order: action.value, page: 0 }),
  });

const setMainExportColumns = (
  state: BinomeListsState,
  action: TypedAction<ExportColumns>,
) =>
  updateObject(state, {
    main: updateObject(state.main, { exportColumns: action.value }),
  });

const binomeListsReducer = (
  state = initialState,
  action: { type: string; value: unknown },
) => {
  switch (action.type) {
    case ActionTypes.MAIN_SET_PAGE:
      if (isNumberAction(action)) return setPage(state, action);
      console.log('Action type error: setPage');
      return state;

    case ActionTypes.MAIN_SET_SEARCH:
      if (isStringAction(action)) return setSearch(state, action);
      console.log('Action type error: setSearch');
      return state;

    case ActionTypes.MAIN_SET_TAGS:
      if (isTagsAction<MainTagColumns>(mainTagColumns, action))
        return setMainTags(state, action);
      console.log('Action type error: setTags');
      return state;

    case ActionTypes.MAIN_SET_EXPORT_COLUMNS:
      if (isColumns(exportColumnNames, action))
        return setMainExportColumns(state, action);
      console.log('Action type error: setExportColumns');
      return state;

    case ActionTypes.MAIN_SET_TAKE:
      if (isNumberAction(action)) return setTake(state, action);
      console.log('Action type error: setTake');
      return state;

    case ActionTypes.MAIN_SET_ORDER:
      if (isOrderAction(mainSortableColumns, action))
        return setOrderMain(state, action);
      console.log('Action type error: setOrder');
      return state;

    default:
      return state;
  }
};

export default binomeListsReducer;